module.exports = __webpack_public_path__ + "static/media/89.5412d457.jpg";